import keyboardFocus from "keyboard-focus";

keyboardFocus(document);

let domReady = (cb) => {
  document.readyState === "interactive" || document.readyState === "complete"
    ? cb()
    : document.addEventListener("DOMContentLoaded", cb);
};

domReady(() => {
  document.body.style.opacity = "1";
});

function handleTables() {
  const tables = document.querySelectorAll(".text-block-wrapper table");

  if (!tables.length) return;

  tables.forEach((table) => {
    if (table.closest(".table-wrapper")) return;

    const scrollWrapper = document.createElement("div");
    scrollWrapper.classList.add("table-wrapper");

    // Restructure the DOM
    table.parentNode.insertBefore(scrollWrapper, table);

    scrollWrapper.appendChild(table);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  handleTables();
});
